module.exports = "https://r.nearpod.com/assets/media/image/immersive-reader-icon-91502d2d81365d6dccd5abcb611551d0.svg";